// extracted by mini-css-extract-plugin
export var auto = "_2i-1";
export var spinner = "_2i-0";